import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../App.scss";

// Import nových obrázků
import img from "../assets/screenshots/img.png";
import img_1 from "../assets/screenshots/img_1.png";
import img_2 from "../assets/screenshots/img_2.png";

const Features = () => {
   const { t } = useTranslation();
   const [currentSlide, setCurrentSlide] = useState<number>(0);

   const images = [
      { src: img, caption: t("features.screenshots.screenshot2") },
      { src: img_1, caption: t("features.screenshots.screenshot3") },
      { src: img_2, caption: t("features.screenshots.screenshot4") },
   ];

   const settings = {
      centerMode: true,
      centerPadding: "0px",
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      dots: true,
      focusOnSelect: true,
      beforeChange: (oldIndex: number, newIndex: number) =>
         setCurrentSlide(newIndex),
      responsive: [
         {
            breakpoint: 768,
            settings: {
               slidesToShow: 1,
               centerPadding: "10px",
            },
         },
      ],
   };

   return (
      <Container className='pt-3 pb-3'>
         <Row className='text-center'>
            <Col>
               <h2 className='features-title '>{t("features.intro.title")}</h2>
               <div className='info-box p-3'>
                  <p>{t("features.intro.description")}</p>
                  <p>{t("features.intro.declaration")}</p>
                  <p>{t("features.intro.osAvailability")}</p>
               </div>

               <h3 className='mt-3 mb-3'>{t("features.carouselTitle")}</h3>
               <div
                  className='carousel-container'
                  style={{ position: "relative" }}
               >
                  <Slider {...settings} className='features-carousel'>
                     {images.map((image, index) => (
                        <div
                           key={index}
                           className={`carousel-slide ${
                              index === currentSlide ? "active" : ""
                           }`}
                           style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                           }}
                        >
                           <img
                              src={image.src}
                              alt={`Screenshot ${index + 1}`}
                              className={`carousel-image ${
                                 index === currentSlide ? "large" : "small"
                              }`}
                           />
                        </div>
                     ))}
                  </Slider>
                  <p
                     className='carousel-caption'
                     style={{
                        fontSize: "18px",
                        color: "#333",
                        textAlign: "center",
                        position: "absolute",
                        bottom: "-70px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: "80%",
                     }}
                  >
                     {images[currentSlide].caption}
                  </p>
               </div>
            </Col>
         </Row>

         <Row>
            <Col>
               <h2 className='features-title-description'>
                  {t("features.usage.title")}
               </h2>
               <p>{t("features.usage.description")}</p>
               <ol>
                  <li>{t("features.usage.step1")}</li>
                  <li>{t("features.usage.step2")}</li>
                  <li>{t("features.usage.step3")}</li>
                  <li>{t("features.usage.step4")}</li>
               </ol>
               <p>{t("features.usage.final")}</p>

               <h2 className='features-title'>
                  {t("features.functions.title")}
               </h2>
               <div>
                  <h4>{t("features.functions.digitization.title")}</h4>
                  <p>{t("features.functions.digitization.content")}</p>
                  {/*<img src={screenshot2} alt="screenshot_digitazation" />*/}
                  {/*TODO ilustrační obrázek*/}
                  <h4>{t("features.functions.categorization.title")}</h4>
                  <p>{t("features.functions.categorization.content")}</p>
                  {/*TODO ilustrační obrázek*/}
                  <h4>{t("features.functions.tracking.title")}</h4>
                  <p>{t("features.functions.tracking.content")}</p>
                  {/*TODO ilustrační obrázek*/}
                  <h4>{t("features.functions.learning.title")}</h4>
                  <p>{t("features.functions.learning.content")}</p>
                  {/*TODO ilustrační obrázek*/}
                  <h4>{t("features.functions.archive.title")}</h4>
                  <p>{t("features.functions.archive.content")}</p>
                  {/*TODO ilustrační obrázek*/}
                  <h4>{t("features.functions.multiCurrency.title")}</h4>
                  <p>{t("features.functions.multiCurrency.content")}</p>
                  {/*TODO ilustrační obrázek*/}
               </div>

               <h2 className='features-title-description'>
                  {t("features.future.title")}
               </h2>
               <h4>{t("features.future.communityComparison.title")}</h4>
               <p>{t("features.future.communityComparison.content")}</p>
               <h4>{t("features.future.smartShopping.title")}</h4>
               <p>{t("features.future.smartShopping.content")}</p>
               <h4>{t("features.future.flyerFinder.title")}</h4>
               <p>{t("features.future.flyerFinder.content")}</p>
               <h4>{t("features.future.aiAssistant.title")}</h4>
               <p>{t("features.future.aiAssistant.content")}</p>
               <h4>{t("features.future.inflationTracker.title")}</h4>
               <p>{t("features.future.inflationTracker.content")}</p>
               <h4>{t("features.future.bankAccountWatcher.title")}</h4>
               <p>{t("features.future.bankAccountWatcher.content")}</p>
               <h4>{t("features.future.budgetPlanning.title")}</h4>
               <p>{t("features.future.budgetPlanning.content")}</p>
               <h4>{t("features.future.familySharing.title")}</h4>
               <p>{t("features.future.familySharing.content")}</p>
               <h4>{t("features.future.priceMap.title")}</h4>
               <p>{t("features.future.priceMap.content")}</p>
               <h4>{t("features.future.invoiceSupport.title")}</h4>
               <p>{t("features.future.invoiceSupport.content")}</p>
            </Col>
         </Row>
      </Container>
   );
};

export default Features;
